import { useState } from "react";
import { useFetch } from "../../hooks/useFetch/useFetch";
import { useParams } from 'react-router-dom';
import { LeftCircleTwoTone, RightCircleTwoTone } from "@ant-design/icons";
import { Image } from "antd";

export const WebPosts = ({id, color, title}) => {

    const { data: posts, isLoading: postsLoading } = useFetch(
        `${process.env.REACT_APP_API}/web/posts?key=${id}`,
        {},
        [],
    );

    const itemsPerPage = 1;
    const [currentPage, setCurrentPage] = useState(1);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentPosts = posts?.slice(startIndex, endIndex);


    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
    };

    return (
        <div className="block" style={{background:`ghostwhite`}}>

            <h1 className='block-title'>{title}</h1>
            <div style={{borderRadius:'10px', height:'6px', width: '250px', margin:'10px', background:`linear-gradient(to right, transparent, ${color})`}}/>                
    
            {currentPosts?.map((post) => (
                <div key={post?.name} className="block-content-50-50" style={{marginTop:'20px'}}>
                    <div className="responsive-50">
                        <Image src={post?.mediaItemsURL?.length > 0 && post?.mediaItemsURL[0]} alt="Imagen Post" style={{ borderRadius:'15px' }} />
                    </div>
                    <div className="responsive-50">{post?.summary}</div>
                </div>
            ))}
    
            <div className="web-buttons">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                    <LeftCircleTwoTone twoToneColor={currentPage === 1 ? "lightgrey" : `${color}`}/>
                </button>
                {/* <span> Página {currentPage} </span> */}
                <button onClick={handleNextPage} disabled={endIndex >= posts.length}>
                    <RightCircleTwoTone twoToneColor={currentPage === posts.length ? "lightgrey" : `${color}`}/>
                </button>
            </div>
        </div>
    );
}
